import React from "react";
import { ButtonBase, LinearProgress, Skeleton, Typography, alpha } from "@mui/material";
import { COLORS, TYPO } from "../../styles/uiConstants";

/**
 * Tıklanabilir özet kutusu — birleşik hasta sekmelerinin (Beslenme, İletişim) üst
 * şeridinde bölüm seçici olarak kullanılır: etiket, tek satır değer, isteğe bağlı
 * ilerleme çubuğu ve ipucu. Seçili kutu tema renginde çerçevelenir.
 *
 * @param {string} label
 * @param {React.ReactNode} value
 * @param {React.ReactNode} [hint]
 * @param {number|null} [progress] - 0–100
 * @param {boolean} [loading]
 * @param {boolean} [active]
 * @param {() => void} onClick
 * @param {object} [palette]
 */
export default function SummaryTile({ label, value, hint, progress, loading, active, onClick, palette }) {
  const tone = palette?.primary || COLORS.slate700;
  return (
    <ButtonBase
      onClick={onClick}
      aria-pressed={active}
      sx={{
        display: "block",
        width: "100%",
        textAlign: "left",
        px: 2,
        py: 1.5,
        borderRadius: 2,
        border: `1px solid ${active ? alpha(tone, 0.5) : COLORS.slate200}`,
        bgcolor: active ? alpha(tone, 0.05) : COLORS.white,
        transition: "border-color 120ms, background-color 120ms",
        "&:hover": { borderColor: alpha(tone, 0.6) },
        "&.Mui-focusVisible": { outline: `2px solid ${alpha(tone, 0.5)}`, outlineOffset: 2 },
      }}
    >
      <Typography sx={{ fontSize: TYPO.caption, color: COLORS.slate500 }}>{label}</Typography>
      {loading ? (
        <>
          <Skeleton width="70%" sx={{ fontSize: TYPO.body }} />
          <Skeleton width="50%" sx={{ fontSize: TYPO.caption }} />
        </>
      ) : (
        <>
          <Typography noWrap sx={{ fontSize: TYPO.body, fontWeight: 500, color: COLORS.slate800, mt: 0.25 }}>
            {value}
          </Typography>
          {progress != null ? (
            <LinearProgress
              variant="determinate"
              value={Math.max(0, Math.min(100, progress))}
              sx={{ mt: 0.75, height: 4, borderRadius: 2, bgcolor: alpha(tone, 0.1), "& .MuiLinearProgress-bar": { bgcolor: tone } }}
            />
          ) : null}
          {hint ? (
            <Typography noWrap sx={{ fontSize: TYPO.caption, color: COLORS.slate500, mt: 0.5 }}>
              {hint}
            </Typography>
          ) : null}
        </>
      )}
    </ButtonBase>
  );
}
